import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/app.tsx';
import { appConfig } from './config.ts';
import './index.css';

async function boot() {
  if (appConfig.useMocks || appConfig.partialMocks) {
    const { startMockWorker } = await import('./mocks/browser.ts');
    await startMockWorker();
  }
  const container = document.getElementById('root');
  if (!container) throw new Error('Falta #root');
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
